import React from 'react'
import styled from 'styled-components'
import OficinaCustomers from './OficinaCustomers'
import "./styles.css"
import VendorsCustomers from './VendorsCustomers'
import WhatchedCustomers from './WhatchedCustomers'
import useBoxes from '../../../hooks/useBoxes'
import useMediaQuery from '../../../hooks/useMediaQuery'
import { SellOrderContext } from '../../../providers/SellOrdersProvider'
import MobileHeader from '../../../components/MobileHeader'
import SegmentedControl from '../../../components/SegmentedControl'

const Container = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  grid-template-rows: minmax(0, 1fr) minmax(0, 1fr);
  grid-template-areas:
    "vendors oficina"
    "vendors watcheds";
  overflow-y: hidden;
  width: 100%;
  height: 100%;
  min-height: 0;
  gap: .75rem;

  @media (max-width: 768px) {
  /* En móvil mantenemos grid de 1x1 para que el panel activo llene y tenga scroll interno */
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: minmax(0, 1fr);
  overflow-y: hidden;
  height: 100%;
  min-height: 0;
  gap: .5rem;
  }
`

// MobileHeader is imported as a reusable component

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: 0;
  padding: .75rem; /* separa del sidebar y navbar */

  @media (max-width: 768px) {
  padding: .25rem; /* aún más compacto en móvil */
  }
`

function SellOrdersPayable() {
  const { boxes } = useBoxes();
  const isMobile = useMediaQuery('(max-width: 768px)');
  const { vendorsSumary, watchedSumary, oficinaSumary } = React.useContext(SellOrderContext);
  const [tab, setTab] = React.useState<'vendedores' | 'observados' | 'oficina'>('vendedores');

  return (
    <Wrapper>
      {isMobile && (
        <MobileHeader
          right={<SegmentedControl
            items={[
              { key: 'vendedores', label: 'Vendedores', count: vendorsSumary.numberOfSales },
              { key: 'observados', label: 'Observados', count: watchedSumary.numberOfSales },
              { key: 'oficina', label: 'Oficina', count: oficinaSumary.numberOfSales },
            ]}
            activeKey={tab}
            onChange={(k) => setTab(k as 'vendedores' | 'observados' | 'oficina')}
          />}
        />
      )}
      <Container>
        {isMobile ? (
          tab === 'vendedores' ? (
            <VendorsCustomers boxes={boxes} />
          ) : tab === 'observados' ? (
            <WhatchedCustomers />
          ) : (
            <OficinaCustomers boxes={boxes} />
          )
        ) : (
          <>
            <VendorsCustomers boxes={boxes}></VendorsCustomers>
            <WhatchedCustomers></WhatchedCustomers>
            <OficinaCustomers boxes={boxes}></OficinaCustomers>
          </>
        )}
      </Container>
    </Wrapper>
  )
}

export default SellOrdersPayable